import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { Page } from '@bit/knotchinc.web-react-components.page';
import PageHeader from 'components/Global/PageHeader/PageHeader.jsx';
import AlertsPage from './AlertsPage.jsx';
import CompetitorsMgmtView from './CompetitorsMgmtView.jsx';
import ProfileMgmtView from './ProfileMgmtView.jsx';
import SubscriptionMgmtView from './SubscriptionMgmtView.jsx';
import { BadgeWrapper } from 'components/Global/Badges/';

export class SettingsView extends React.Component {
  render() {
    const { match } = this.props;

    const tabs = [
      { text: 'Profile', title: 'Profile', link: `${match.url}/profile` },
      { text: 'Competitors', title: 'Competitors', link: `${match.url}/competitors` },
      { text: 'subscriptions', title: 'subscriptions', link: `${match.url}/subscriptions` },
      { text: <BadgeWrapper text="Alerts" badge="newItem" position="after" />, title: 'Alerts', link: `${match.url}/alerts` },
    ];

    return (
      <Page>
        <PageHeader title={`Settings`} fetched tabs={tabs} />
        <Switch>
          <Redirect exact from={match.path} to={`${match.path}/profile`} />
          <Route exact path={`${match.path}/profile`} component={ProfileMgmtView} />
          <Route exact path={`${match.path}/alerts`} component={AlertsPage} />
          <Route exact path={`${match.path}/competitors`} component={CompetitorsMgmtView} />
          <Route exact path={`${match.path}/subscriptions`} component={SubscriptionMgmtView} />
        </Switch>
      </Page>
    );
  }
}

export default SettingsView;

